"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removePrefix = exports.getHashValue = exports.default = void 0;
const getHashValue = key => {
  const matches = window.location.hash.match(new RegExp(`${key}=([^&]*)`));
  return matches ? matches[1] : null;
};
exports.getHashValue = getHashValue;
const removePrefix = (path, prefix) => path.replace(prefix, '');
exports.removePrefix = removePrefix;
var _default = exports.default = getHashValue;